import { SidePanelVariant, ISidePanelSize } from './SidePanel.interface';

export const panelSizes: Record<SidePanelVariant, ISidePanelSize> = {
  [SidePanelVariant.Left]: {
    defaultSize: 11,
    minSize: 10,
    maxSize: 25,
  },
  [SidePanelVariant.Right]: {
    defaultSize: 25,
    minSize: 20,
    maxSize: 50,
  },
};
